import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p9310Api, QueryParams, AttendanceRow } from '../../../services/p9310Api';

export function useP9310Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AttendanceRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p9310Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number; data?: { details?: string[] } } };
      if (axiosErr.response?.status === 422) {
        const details = axiosErr.response.data?.details || [];
        message.error(details.join('\n') || '查詢參數驗證失敗');
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, queried, noData, runQuery, reset };
}
